export default __webpack_public_path__ + "static/media/menu-bar.9c74a425.svg";